let job_strings = {
    'sendNotification' : 'sendNotification',
    'synchronizeMail' : 'synchronizeMail',
}

export default {job_strings}